$(function() {

  'use strict';

  var _this,
      _window = $(window);

  /**
   * _cards.scss
   */
  $(function() {
    _window.on('load', function() {
      if(_window.width() > 1024) {
        $('#service .card__title-en').matchHeight();
        $('#service .card__title-ja').matchHeight();
        $('#service .card__catch').matchHeight();
        $('#service .card__list-wrapper').matchHeight();
      }
    });

    _window.on('resize', function() {
      if(_window.width() > 1024) {
        $('#service .card__title-en').matchHeight();
        $('#service .card__title-ja').matchHeight();
        $('#service .card__catch').matchHeight();
        $('#service .card__list-wrapper').matchHeight();
      }
    });
  });

});
